import { render, staticRenderFns } from "./stock-incrementer.vue?vue&type=template&id=a15a0530&scoped=true&"
import script from "./stock-incrementer.vue?vue&type=script&lang=js&"
export * from "./stock-incrementer.vue?vue&type=script&lang=js&"
import style0 from "./stock-incrementer.vue?vue&type=style&index=0&id=a15a0530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a0530",
  null
  
)

export default component.exports